/**
 * Desactiva el autofill del navegador (Chrome: "direcciones guardadas" y el
 * desplegable de valores anteriores) en TODO el ERP, marcando formularios y
 * campos con autocomplete="off" automáticamente, también en los que se montan
 * después (modales, etc.) vía MutationObserver.
 *
 * Excepciones:
 * - type="password" y type="email" dentro de formularios de login: no se tocan
 *   para que el gestor de contraseñas siga funcionando.
 * - Cualquier elemento con data-allow-autofill.
 *
 * Nota: Chrome ignora a veces autocomplete="off" en campos que detecta como
 * dirección. Para esos casos el componente DireccionAutocomplete ya usa un
 * textarea de una línea (el autofill solo actúa sobre inputs).
 */
export function desactivarAutofillGlobal() {
  const esExcepcion = (el) => {
    if (el.dataset && el.dataset.allowAutofill !== undefined) return true;
    if (el.type === 'password') return true;
    // No tocar los campos del login (email + password) para el gestor de claves
    if (el.closest && el.closest('form[data-login-form]')) return true;
    return false;
  };

  const aplicar = (root) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('form').forEach((f) => {
      if (f.dataset.allowAutofill === undefined && f.dataset.loginForm === undefined) {
        f.setAttribute('autocomplete', 'off');
      }
    });
    root.querySelectorAll('input, select, textarea').forEach((el) => {
      if (!esExcepcion(el)) el.setAttribute('autocomplete', 'off');
    });
  };

  aplicar(document);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) aplicar(n);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}
